import { render, staticRenderFns } from "./LoanRejectionButton.vue?vue&type=template&id=5600a6c6&"
import script from "./LoanRejectionButton.vue?vue&type=script&lang=js&"
export * from "./LoanRejectionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports